export default {
  "oti": [],
  "houseowners": [],
  "comprehensive": [],
  "thirdparty": [],
  "muendebwino": []
}